import React from 'react'
import "../styles/sliderStyles.css";

function Slider({advanatge, max, labelMax, labelMin}) {
  const widthSlider = max * 2;
  const percentAdv = 100 / widthSlider;
  const currentValue = (Math.abs(advanatge) > max ? advanatge > 0 ? max : -1 * max : advanatge) * percentAdv;

  const sliderStyles = {
    width: '100%',
    height: '2px',
    backgroundColor: '#fff',
    borderRadius: '2px',
  }
  
  return (
    <div className='container_space'>
      <div className="container_slider">
        <div style={sliderStyles} className="slider"/>
        <div className="slider_thumb" style={{left: (50 - currentValue) + "%"}}/>
        <div className="slider_active" style={{[currentValue >= 0 ? 'right': 'left']: '50%', width: Math.abs(currentValue) + '%'}}/>
        <div className='slider_start'>|</div>
        <div className="adv_value" style={{left: (50 - currentValue) + "%"}}>{advanatge}</div>
        <div className="adv_value" style={{left: "8%", top: -40}}>{labelMax}</div>
        <div className="adv_value" style={{right: "-8%", top: -40}}>{labelMin}</div>
      </div>      
    </div>
  )
}

export default Slider
